import { createFileRoute } from "@tanstack/react-router";
import { SubPage } from "@/components/sub-page";

export const Route = createFileRoute("/quienes-somos/que-es")({
  head: () => ({
    meta: [
      { title: "Qué es Mine Class | Mine Class" },
      { name: "description", content: "Empresa de tecnología especializada en soluciones digitales para la industria minera." },
      { property: "og:title", content: "Qué es Mine Class | Mine Class" },
      { property: "og:description", content: "Somos una empresa de tecnología con soluciones digitales especializadas para la industria minera." },
      { property: "og:url", content: "https://mine-class.com/quienes-somos/que-es" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/quienes-somos/que-es" }],
  }),
  component: Page,
});

function Page() {
  return (
    <SubPage section="quienes-somos"
      eyebrow="Quiénes Somos"
      title="Qué es Mine Class"
      intro="Somos una empresa de tecnología especializada en desarrollar soluciones digitales para la industria minera."
    >
      <div className="space-y-6 text-[var(--color-on-surface-variant)] text-lg leading-relaxed">
        <p>
          Nuestra historia comenzó hace más de 11 años como una OTEC enfocada en capacitación minera. Ese recorrido nos entregó
          un conocimiento único sobre los procesos de formación, acreditación y cumplimiento en faena. Con esa experiencia
          evolucionamos hacia una empresa de software e inteligencia artificial que hoy impulsa la transformación digital de la
          gestión de personas en minería.
        </p>
        <p>
          Nuestro portafolio incluye plataformas como <strong>Mine Pass</strong>, que digitaliza y automatiza los procesos de
          acreditación e ingreso a faena, y <strong>VigIA</strong>, nuestra plataforma de inteligencia artificial para la gestión
          documental en minería.
        </p>
        <p>
          Actualmente colaboramos con más de 500 empresas proveedoras del sector minero en Chile, Perú y Argentina e impactamos a
          más de 700 personas al día, combinando tecnología, inteligencia artificial y experiencia operacional para construir una
          minería más eficiente, segura y conectada.
        </p>
      </div>
    </SubPage>
  );
}
